import React from 'react';
import our_ethos from '../../assests/img/our-ethosa.jpg';

const OurEthos = () => {

    return (
        <>
            <div className='inner_top_about_us'>
                <div id="bg" className="data-typography-1 data-theme-1">
                    <div className="page-wraper">
                        <div className="page-content bg-white">
                            <div className="dz-bnr-inr dz-bnr-inr-sm style-1 text-center overlay-primary-dark">
                                <div className="coustom_container">
                                    <div className="dz-bnr-inr-entry">
                                        <div className="pheading">
                                            <h1>Our Ethos</h1>
                                        </div>
                                        <nav aria-label="breadcrumb" className="breadcrumb-row">
                                            <ul className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <a href="/">Home</a>
                                                </li>
                                                <li className="mx-2">
                                                    /
                                                </li>
                                                <li className="breadcrumb-item active" aria-current="page">
                                                    Our Ethos
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>


                            <section className="content-inner section-wrapper5 pt-5 pb-5">
                                <div className="coustom_container">
                                    <div className="row">
                                        <div
                                            className="col-xl-9 col-lg-6 m-b30 wow fadeInUp"
                                            data-wow-delay="0.4s"
                                        >
                                            <div id="pagedata" className="pagedata">
                                                <p style={{ textAlign: "justify" }}>
                                                    <img src={our_ethos} alt="our-ethos" width="100%" />
                                                </p>
                                                <p><em>
                                                    एकं सद्विप्रा बहुधा वदन्ति (“Ekam Sat Viprah Bahudha Vadanti”): Truth is one, the wise perceive it differently.
                                                </em></p>
                                                <p>This core value is at the heart of our school. This is the central theme based on which the entire foundation of the Indian civilisation, its endless religions and sects, its culture, and its education has been built. This is a “core value” system that India espouses, which Indians live by. This value system naturally leads to acceptance, and even respect for all.</p>
                                                <p>At KCMS we combine tradition with a modern outlook, the local with the international and academic rigour with real life application thus meeting the needs of all learners.</p>
                                            </div>
                                        </div>

                                        <div
                                            className="col-xl-3 col-lg-6 wow fadeInUp"
                                            data-wow-delay="0.2s"
                                        >
                                            <div className="bg-lgrey">
                                                <div className="subMenubg active">
                                                    <a href="about-us" target="_self" className="submenu">
                                                        About Us
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="our-inspiration"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Our Inspiration
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="history" target="_self" className="submenu">
                                                        History
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a className="submenu">
                                                        Messages
                                                    </a>
                                                    <div className="founder_link">
                                                        <div className="subMenubg">
                                                            <a href="founder-message" className="submenu">
                                                                Founder’s Message
                                                            </a>
                                                        </div>
                                                        <div className="subMenubg">
                                                            <a href="director-message" className="submenu">
                                                                Director’s Message
                                                            </a>
                                                        </div>
                                                        <div className="subMenubg">
                                                            <a href="patron-message" className="submenu">
                                                                Patron Message
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="our-aims" target="_self" className="submenu">
                                                        Our Aims
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="our-ethos"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Our Ethos
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="our-vision.html"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Our Vision
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>

                        {/* <button className="scroltop icon-up" type="button">
                            <i className="fas fa-arrow-up"></i>
                        </button> */}
                    </div>
                </div>
            </div >
        </>
    )
}

export default OurEthos;